const ONE_SECOND = 1000

// Common set of TTLs for queries
export const TTL = {
  "2s": ONE_SECOND * 2,
  "15s": ONE_SECOND * 15,
  "5m": ONE_SECOND * 60 * 5,
}
